const crossOriginPageUrl = process.env.REACT_APP_nvidiaauthhints;
//const crossOriginPageUrl = process.env.nvidiaauthhints;

export function readHint() {
  return new Promise((resolve, reject) => {
    if (!crossOriginPageUrl) {
      reject(new Error("Starfleet hints URL is not configured."));
      return;
    }

    let targetOrigin;

    try {
      targetOrigin = new URL(crossOriginPageUrl).origin;
    } catch {
      reject(new Error("Starfleet hints URL is invalid."));
      return;
    }

    const iframe = document.createElement("iframe");
    iframe.hidden = true;
    iframe.src = crossOriginPageUrl;

    let settled = false;
    let timeoutId;

    const cleanup = () => {
      window.removeEventListener("message", responseHandler);
      clearTimeout(timeoutId);
      iframe.remove();
    };

    const finish = (callback, value) => {
      if (settled) return;
      settled = true;
      cleanup();
      callback(value);
    };

    const responseHandler = (event) => {
      // Verify both the expected origin and the specific iframe.
      if (event.origin !== targetOrigin) return;
      if (event.source !== iframe.contentWindow) return;

      const data = event.data;

      if (!data || !["success", "error"].includes(data.type)) {
        return;
      }

      console.log("[readHint] Starfleet response type:", data.type);

      if (data.type === "error") {
        finish(
          reject,
          new Error(
            data.payload?.message ||
              "Starfleet hints request failed."
          )
        );
        return;
      }

      finish(resolve, data.payload ?? null);
    };

    // Register the listener before sending the request.
    window.addEventListener("message", responseHandler);

    timeoutId = setTimeout(() => {
      finish(
        reject,
        new Error(
          "Timed out waiting for the Starfleet hints response."
        )
      );
    }, 10000);

    iframe.onload = () => {
      if (settled) return;

      iframe.contentWindow.postMessage(
        { type: "read" },
        targetOrigin
      );

      console.log("[readHint] Read request sent");
    };

    iframe.onerror = () => {
      finish(
        reject,
        new Error("Failed to load the Starfleet hints iframe.")
      );
    };

    document.body.appendChild(iframe);
  });
}



export function writeUser(login_hint, idp_id, timestamp, sub) {  
  const { origin: targetOrigin } = new URL(crossOriginPageUrl);
  const iframeDOC = document.getElementById("NGC_Iframe");
  if (iframeDOC) {
    document.body.removeChild(iframeDOC);
  }
  const iframe = document.createElement("iframe");
  iframe.hidden = true;
  iframe.src = crossOriginPageUrl;
  iframe.id = "NGC_Iframe";
  var func = function () {
    const message = { type: "write", login_hint, idp_id, timestamp, sub };
    iframe.contentWindow.postMessage(message, targetOrigin);
    console.log("loaded!");
  };
  if (iframe.addEventListener) iframe.addEventListener("load", func, true);
  else if (iframe.attachEvent) iframe.attachEvent("onload", func);

  document.body.appendChild(iframe);
}



export function writeHint(login_hint, idp_id, timestamp, sub) {
  console.log("[writeHint] Started");

  return new Promise((resolve) => {
    const { origin: targetOrigin } = new URL(crossOriginPageUrl);

    console.log("[writeHint] targetOrigin:", targetOrigin);
    console.log("[writeHint] crossOriginPageUrl:", crossOriginPageUrl);

    const iframeDOC = document.getElementById("NPN_Iframe");

    if (iframeDOC) {
      console.log("[writeHint] Existing iframe found. Removing old iframe.");
      document.body.removeChild(iframeDOC);
    }

    const iframe = document.createElement("iframe");
    iframe.hidden = true;
    iframe.src = crossOriginPageUrl;
    iframe.id = "NPN_Iframe";

    console.log("[writeHint] New iframe created");

    // Convert timestamp to ISO format with milliseconds
    timestamp = new Date(timestamp * 1000).toISOString();

    console.log("[writeHint] Converted timestamp:", timestamp);

    iframe.onload = () => {
      const message = { type: 'write', login_hint, idp_id, timestamp, sub };
      iframe.contentWindow.postMessage(message, targetOrigin);

      // wait briefly before resolving
      setTimeout(() => {
        console.log("[writeHint] Promise resolved");
        resolve(true);
      }, 500);
    };

    iframe.onerror = (error) => {
      console.error("[writeHint] iframe failed to load", error);
      resolve(false);
    };

    console.log("[writeHint] Appending iframe to body");

    document.body.appendChild(iframe);
  });
}

export function deleteUser() {
  const { origin: targetOrigin } = new URL(crossOriginPageUrl);
  const iframe = document.createElement("iframe");
  iframe.hidden = true;
  iframe.src = crossOriginPageUrl;
  iframe.onload = () => {
    iframe.contentWindow.postMessage({ type: "delete" }, targetOrigin);
  };
  document.body.appendChild(iframe);
}
